import React from 'react'

import { faSignOutAlt } from '@fortawesome/pro-regular-svg-icons'
import { List } from '@material-ui/core'
import { head } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { useLogout } from 'common/use-logout.ts'
import withContext from 'components/RealtimeMessagingProvider/withContext'
import { actions as compareActions } from 'store/college-compare'
import { selectUser } from 'store/user'

import SidebarListItem from './SidebarListItem'

/**
 * This component displays actions in the top-nav sidebar
 * @param {object} props
 * @prop {string} userType
 * @prop {func} realtimeLogout
 * @returns Component displaying list of actions for sidebar
 */
export const LogoutButton = (props) => {
  const logout = useLogout(props)

  return (
    <List>
      <SidebarListItem
        icon={faSignOutAlt}
        id="main-nav-sign-out"
        label="Log Out"
        onSelectLink={logout}
      />
    </List>
  )
}

LogoutButton.propTypes = {
  userType: PropTypes.string,
  onSelectLink: PropTypes.func,
  realtimeLogout: PropTypes.func.isRequired,
  clearCollegeCompare: PropTypes.func.isRequired,
}

const ConnectedLogoutButton = connect(
  (store) => {
    const user = selectUser(store)
    return {
      userType: head(user.UserTypes),
    }
  },
  {
    clearCollegeCompare: compareActions.clearCollegeCompare,
  },
)(LogoutButton)

export default withContext({
  logout: 'realtimeLogout',
})(ConnectedLogoutButton)
